const GetDataType = 
  `query Query($id: String!) {
    dataType(id: $id) {
      description
      id
      name
    }  
  }
  `

  const GetDataTypes =
  `query Query($count: Int, $cursor: String, $filterConfig: DataTypeFilterConfigInput) {
    dataTypes(first: $count, after: $cursor, filterConfig: $filterConfig) {
      pageInfo {
        hasNextPage
      }
      edges {
          cursor
          node {
            description
            id
            name          
          }        
        }  	
      }    
    }      
  `

  module.exports = {
    GetDataType,
    GetDataTypes,
  }